const QUERIES = {
  USERS_LIST: 'users-list',
  CUSTOMERS_LIST: 'customers-list',
  ORDERS_LIST: 'orders-list',
}

export {QUERIES}
